import React from 'react'

import moment from 'moment'

import { ModalTrigger, ModalAlojamiento, ModalPasaje } from './Modales.jsx'

import css from './Fondos.css'

moment.locale('es')
let PropTypes = React.PropTypes

export class RowFondos extends React.Component{
    constructor(props){
        super(props)
        this.inputOnKeyDown = this.inputOnKeyDown.bind(this)
        this.state = {
            servicio: [],
            comprobante: ''
        }
        this.onInputChange = (key, evt)=>{
            let actualizado = {}
            actualizado[key] = evt.target.type === 'checkbox'? evt.target.checked : evt.target.value
            actualizado.dirty = 1
            this.setState({ servicio: Object.assign({}, this.state.servicio, actualizado)}, ()=> this.context.inputChange(this.props.index, this.state.servicio))
        }
        this.onInputBlur =()=>{
            if(this.state.servicio.dirty)
                this.context.guardarFondo(this.state.servicio)
        }
    }
    onComprobanteChange(evt){
        if(evt.target.files[0]){
            let actualizado = {}
            actualizado.comprobante = evt.target.files[0]
            this.setState({ servicio: Object.assign({}, this.state.servicio, actualizado)}, ()=> this.context.subirComprobante(this.props.index, this.state.servicio))
        }
    }
    focusElemento(elemento){
        this[elemento].focus()
    }
    inputOnKeyDown(key, evt){
        if((evt.keyCode===9 && evt.shiftKey===false) || evt.keyCode===40 || evt.keyCode===13){
            // 9 = tab, flechaAbajo = 40,  13 = enter
            evt.preventDefault()
            this.props.focusRow(this.props.index+1, key)

        }else if((evt.keyCode===9 && evt.shiftKey===true) || evt.keyCode===38) {
            // flechaArriba = 38, shift+tab
            evt.preventDefault()
            this.props.focusRow(this.props.index-1, key)
        }
    }
    componentWillMount(){
        this.setState({
            servicio: this.props.servicio
        })
    }
    render() {
        return (
            <tr key={this.props.index}>
                {/* Dia Trabajado*/}
                <td className={css.tdDiaTrabajado}>
                    {
                        this.props.totales?
                            null
                        :
                            <div>
                                <div className="text-center">
                                    <input type="checkbox" placeholder="Dia Trabajado" id={this.props.index}
                                        ref={(diaTrabajado) => { this.inputDiaTrabajado = diaTrabajado }}
                                        checked={this.state.servicio.diaTrabajado}
                                        //onFocus={()=>{ this.inputDiaTrabajado.select() }}
                                        onKeyDown={this.inputOnKeyDown.bind(this, 'diaTrabajado')}                            
                                        onChange={this.onInputChange.bind(this, 'diaTrabajado')}
                                        disabled={!this.props.puedeModificar}
                                    />
                                </div>
                            </div>
                    }
                </td>
                {/* Dia */}
                <td className={css.tdDia}>
                    <div>
                        {this.props.totales? null : moment(this.state.servicio.dia).format('dddd D MMM')}
                    </div>
                </td>
                {/* Cantidad Servicios */}
                <td className={css.tdServicios}>
                    <div className={"text-center "+css.totales}>
                        {this.props.totales? 
                                <strong>Totales</strong> 
                            : 
                                this.state.servicio.cantidad_servicios
                        }
                    </div>
                </td>
                {/* Colacion Noche */}
                <td className={css.tdColNoche}>
                    {
                        this.props.totales?
                            <div className={"text-center "+css.totales}>
                                <strong>{this.props.totalColacionNocturna.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                        :
                            <input type="number" className={"form-control "+css.inputFondos}
                                ref={(colacion_nocturna) => { this.inputColacion_nocturna = colacion_nocturna }}
                                min="0"
                                value={this.state.servicio.colacion_nocturna}
                                disabled={!this.state.servicio.diaTrabajado}
                                //onFocus={()=>{ this.inputColacion_nocturna.select() }}
                                onKeyDown={this.inputOnKeyDown.bind(this, 'inputColacion_nocturna')}
                                onChange={this.onInputChange.bind(this, 'colacion_nocturna')}
                                onBlur={this.onInputBlur}
                                disabled={!this.props.puedeModificar}
                            />
                    }
                </td>
                {/* Viático */}
                <td className={css.tdViatico}>
                    {
                        this.props.totales?
                            <div className={"text-center "+css.totales}>
                                <strong>{this.props.totalViatico.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                        :
                            <input type="number" className={"form-control "+css.inputFondos}
                                ref={(viatico) => { this.inputViatico = viatico }}
                                min="0"
                                value={this.state.servicio.viatico}
                                disabled={!this.state.servicio.diaTrabajado}
                                //onFocus={()=>{ this.inputViatico.select() }}
                                onKeyDown={this.inputOnKeyDown.bind(this, 'inputViatico')}
                                onChange={this.onInputChange.bind(this, 'viatico')}
                                onBlur={this.onInputBlur}
                                disabled={!this.props.puedeModificar}
                            />
                    }
                </td>
                {/* Acercamiento */}
                <td className={css.tdAcercamiento}>
                    {
                        this.props.totales?
                            <div className={"text-center "+css.totales}>
                                <strong>{this.props.totalAcercmientos.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                        :
                            <input type="number" className={"form-control "+css.inputFondos}
                                ref={(acercamientos) => { this.inputAcercamientos = acercamientos }}
                                min="0"
                                value={this.state.servicio.acercamientos}
                                disabled={!this.state.servicio.diaTrabajado}
                                //onFocus={()=>{ this.inputAcercamientos.select() }}
                                onKeyDown={this.inputOnKeyDown.bind(this, 'inputAcercamientos')}
                                onChange={this.onInputChange.bind(this, 'acercamientos')}
                                onBlur={this.onInputBlur}
                                disabled={!this.props.puedeModificar}
                            />
                    }
                </td>
                {/* Traslados */}
                <td className={css.tdTraslado}>
                    {
                        this.props.totales?
                            <div className={"text-center "+css.totales}>
                                <strong>{this.props.totalTraslados.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                        :
                        <input type="number" className={"form-control "+css.inputFondos}
                            ref={(traslados) => { this.inputTraslados = traslados }}
                            min="0"
                            value={this.state.servicio.traslados}
                            disabled={this.state.servicio.pasajeSei || !this.state.servicio.diaTrabajado}
                            //onFocus={()=>{ this.inputTraslados.select() }}
                            onKeyDown={this.inputOnKeyDown.bind(this, 'inputTraslados')}
                            onChange={this.onInputChange.bind(this, 'traslados')}
                            onBlur={this.onInputBlur}
                            disabled={!this.props.puedeModificar}
                        />
                    }
                </td>
                {/* Pasaje Operador */}
                <td className={css.tdPasajeOperador}>
                    {
                        this.props.totales?
                            <div className={"text-center "+css.totales}>
                                <strong>{this.props.totalPasajeOperador.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                        :
                        <input type="number" className={"form-control "+css.inputFondos}
                            ref={(pasajeOperador) => { this.inputPasajeOperador = pasajeOperador }}
                            min="0"
                            value={this.state.servicio.pasajeOperador}
                            disabled={!this.state.servicio.diaTrabajado}
                            //onFocus={()=>{ this.inputPasajeOperador.select() }}
                            onKeyDown={this.inputOnKeyDown.bind(this, 'inputPasajeOperador')}
                            onChange={this.onInputChange.bind(this, 'pasajeOperador')}
                            onBlur={this.onInputBlur} 
                            disabled={!this.props.puedeModificar}
                        />
                    }
                </td>
                {/* Otros */}
                <td className={css.tdOtros}>
                    {
                        this.props.totales?
                            <div className={"text-center "+css.totales}>
                                <strong>{this.props.totalOtros.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</strong>
                            </div>
                        :
                        <input type="number" className={"form-control "+css.inputFondos}
                            ref={(otros) => { this.inputOtros = otros }}
                            min="0"
                            value={this.state.servicio.otros}
                            disabled={!this.state.servicio.diaTrabajado}
                            //onFocus={()=>{ this.inputOtros.select() }}
                            onKeyDown={this.inputOnKeyDown.bind(this, 'inputOtros')}
                            onChange={this.onInputChange.bind(this, 'otros')}
                            onBlur={this.onInputBlur} 
                            disabled={!this.props.puedeModificar}
                        />
                    }
                </td>
                {/* Pasaje SEI */}
                <td className={css.tdPasajeSei}>
                    {
                        this.props.totales?
                            null
                        :
                            <div>
                                <div className="col-md-6 text-center">
                                    <input type="checkbox" placeholder="Pasaje SEI" id={this.props.index} className={"form-control "+css.inputFondos}
                                        ref={(pasajeSei) => { this.inputPasajeSei = pasajeSei }}
                                        checked={this.state.servicio.pasajeSei}
                                        disabled={!this.state.servicio.diaTrabajado}
                                        onKeyDown={this.inputOnKeyDown.bind(this, 'inputPasajeSei')}                            
                                        onChange={this.onInputChange.bind(this, 'pasajeSei')}
                                        onBlur={this.onInputBlur} 
                                        disabled={!this.props.puedeModificar}
                                    />
                                </div>
                                <div className={"col-md-6 pull-left "+css.inputFondos}>
                                    {
                                        this.state.servicio.pasajeSei?
                                            <div>         
                                                <div className="col-md-3">
                                                    <ModalTrigger>
                                                        {(isVisible, showModal, hideModal)=>
                                                            <div>
                                                                <span className="btn btn-xs btn-success glyphicon glyphicon-open-file" 
                                                                    onClick={showModal} 
                                                                    disabled={!this.state.servicio.diaTrabajado && !this.props.puedeModificar}
                                                                    title="Subir pasaje"/>
                                                                {isVisible && <ModalPasaje
                                                                    hideModal={hideModal}
                                                                    index={this.props.index}
                                                                    servicio={this.state.servicio}
                                                                    boletoPasaje={this.state.servicio.boletoPasaje}
                                                                />}
                                                            </div>
                                                        }
                                                    </ModalTrigger>
                                                </div>
                                            </div>
                                        :
                                            null
                                    }
                                </div>
                            </div>
                    }
                </td>
                {/* Alojamiento */}
                <td className={css.tdAlojamiento}>
                    {
                        this.props.totales?
                            <div className={"text-center "+css.totales}>
                                <strong></strong>
                            </div>
                            :
                            <div>
                                <div className="col-md-12 text-center">
                                    <ModalTrigger>
                                        {(isVisible, showModal, hideModal)=>
                                            <div>
                                                <span className={this.state.servicio.pedirAlojamiento? "btn btn-xs btn-success glyphicon glyphicon-search" : "btn btn-xs btn-warning glyphicon glyphicon-search"}
                                                      onClick={showModal}
                                                      disabled={!this.state.servicio.diaTrabajado}
                                                      title={this.state.servicio.pedirAlojamiento? "Ciudad de inventario es distinta a cuidad de origen de lider" : "Ciudad de inventario es igual a cuidad de origen de lider"}/>
                                                {isVisible && <ModalAlojamiento
                                                    hideModal={hideModal}
                                                    comuna={this.state.servicio.comunaInventarioActual}
                                                    idDetalleHospedaje={this.state.servicio.idDetalleHospedaje}
                                                    idHospedaje={this.state.servicio.idHospedaje}
                                                    index={this.props.index}
                                                    servicio={this.state.servicio}
                                                />}
                                            </div>
                                        }
                                    </ModalTrigger>
                                </div>
                            </div>
                    }
                </td>
            </tr>
        )
    }
}
RowFondos.contextTypes = {
    inputChange: PropTypes.func,
    subirComprobante: PropTypes.func,
    guardarFondo: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/asignacion-fondos/RowFondos.jsx